import React from "react";
import {
  parseAmount,
  CURRENCY_EURO,
  invoiceColorState,
  addHtmlElementClass,
  removeHtmlElementClass,
  scrollHtmlElementIntoView
} from "../../utils/utils";
import I18n from "i18n-js";




const InvoiceDetails = ({
 invoice,
 isSuperMiddleman
}) => {

  return (
    <div className="d-flex justify-content-end flex-wrap align-items-center px-0 px-md-2">
      {
        isSuperMiddleman && invoice.middleman &&
          <div
            className="d-none middleman-label justify-content-center text-center align-items-center bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1">
            <span>{invoice.middleman}</span>
          </div>
      }

      {
        invoice.emitted_at &&
        <div
          className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/calendar.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-flex d-sm-none">{I18n.t('js.indexInvoices.emissionDateCompact')}:&nbsp;</span>
          <span className="d-none d-sm-flex d-lg-none d-xl-flex">{I18n.t('js.indexInvoices.emissionDate')}:&nbsp;</span>
          <b>{invoice.emitted_at}</b>
        </div>
      }

      {
        invoice.expired_at &&
        <div
          className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/hourglass.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-flex d-lg-none d-xl-flex">{I18n.t('js.indexInvoices.expirationDate')}:&nbsp;</span>
          <b>{invoice.expired_at}</b>
        </div>
      }

      {
        invoice.amount &&
        <div
          className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/money.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-flex d-lg-none d-xl-flex">{I18n.t('js.indexInvoices.amount')}:&nbsp;</span>
          <b>{parseAmount(invoice.amount, 2, true)}{CURRENCY_EURO}</b>
        </div>
      }

      <div
        className="bg-intense-blue-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
        <a href={invoice.invoice_link} className="d-flex justify-content-center align-items-center text-center text-white">
          <img src={window.location.origin + '/images/icons/white/download-pdf.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span>{I18n.t('js.indexInvoices.download').toUpperCase()}</span>
        </a>
      </div>
    </div>
  )
}


const InvoiceList = ({
   invoices,
   setInvoices,
   invoicesAnimationDivider,
   isSuperMiddleman
 }) => {

  // Funzione che verifica se una certa fattura ha le sue voci di spesa
  const invoiceRowsPresent = (invoice) => {
    return invoice.invoice_rows && invoice.invoice_rows.length > 0;
  }


  // Funzione che aggiorna una determinata fattura sull'interfaccia grafica
  const handleChangeInvoiceParams = (invoice) => {
    let newInvoices = invoices.map((s) => {
      return s.id === invoice.id ? { ...invoice } : s
    });
    setInvoices(newInvoices)
  }


  // Funzione che gestisce il rendering sull'ìnterfaccia grafica della freccia che indica all'utente la possibilità
  // di espandere / compatare una fattura sulla vista
  const handleDisplayInvoiceArrowDown = (invoice, display) => {
    if (invoiceRowsPresent(invoice)) {
      if (window.innerWidth >= 768) {
        removeHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-md-1');
        removeHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-md-0');
        removeHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-xxxl-2');
        removeHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-xxxl-0');

        if (display) {
          addHtmlElementClass(document, `invoice_number_${invoice.id}`, 'd-none');
          removeHtmlElementClass(document, `invoice_arrow_down_${invoice.id}`, 'd-none');
        } else {
          removeHtmlElementClass(document, `invoice_number_${invoice.id}`, 'd-none');
          addHtmlElementClass(document, `invoice_arrow_down_${invoice.id}`, 'd-none');
          addHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-md-1');
          addHtmlElementClass(document, `invoice_number_container_${invoice.id}`, 'px-xxxl-2');
        }
      }
    }
  }


  return (
    <div className="row w-100 p-0 mx-0 mt-0 mb-5">
      {invoices.map((invoice, i) =>
        <div key={invoice.id} id={invoice.id}
             className="invoice_container col-12 d-block d-md-flex my-3 px-3 px-md-0"
            //  style={{animation: `scale-up 0.5s ease-out ${0.100 * (i % invoicesAnimationDivider)}s forwards`}}
        >
          {
            invoiceRowsPresent(invoice) &&
              <div className="d-flex d-md-none align-items-start justify-content-start pb-2 px-2">
                <img
                  src={window.location.origin + `/images/icons/blue/arrow-${invoice.display_content ? 'up' : 'down'}.svg`}
                  alt="" width="18px"
                  onClick={() => {
                    handleChangeInvoiceParams({
                      ...invoice,
                      display_content: !invoice.display_content
                    })
                    if (!invoice.display_content)
                      setTimeout(() => scrollHtmlElementIntoView(document, `invoice_${invoice.id}_content`, false), 2 * (600 / 3))
                  }}/>
              </div>
          }

          <div className="w-100 p-0">
            <div
              className={`row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px 
              ${invoice.display_content ? 'bg-lg-aig-light-gradient' : (invoiceRowsPresent(invoice) ? 'on-hover-bg-lg-aig-light-gradient' : '')}`}>
              <div className={`col-5 col-md-2 col-xl-1 bg-aig-gradient color-white
                d-flex justify-content-center justify-content-md-center align-items-center
                px-0 px-md-1 px-xxxl-2 minH-40px-imp z-index-10
                ${invoiceRowsPresent(invoice) ? 'cursor-pointer' : ''}
                br-top-left-8px br-bottom-left-0px br-bottom-right-8px
                br-bottom-left-md-8px br-bottom-right-md-0px`}
                   id={`invoice_number_container_${invoice.id}`}
                   onMouseOver={() => handleDisplayInvoiceArrowDown(invoice, true)}
                   onMouseOut={() => handleDisplayInvoiceArrowDown(invoice, false)}
                   onClick={(e) => {
                     if (invoiceRowsPresent(invoice)) {
                       if (window.innerWidth >= 768) {
                         handleChangeInvoiceParams({...invoice, display_content: !invoice.display_content})
                         e.stopPropagation()
                       }
                       if (!invoice.display_content)
                         setTimeout(() => scrollHtmlElementIntoView(document, `invoice_${invoice.id}_content`, false), 2 * (600 / 3))
                     }
                   }}
              >
                <p className={`my-0 ${invoice.number ? 'd-none' : ''}`}
                   id={`invoice_arrow_down_${invoice.id}`}>
                  <img
                    src={window.location.origin + `/images/icons/white/arrow-${invoice.display_content ? 'up' : 'down'}.svg`}
                    alt="" width="18px"/>
                </p>

                <b className={`font-size-xxxl-16px ${!invoice.number ? 'd-none' : ''}`}
                   id={`invoice_number_${invoice.id}`}>
                  {invoice.number}
                </b>
              </div>

              <div className="col-2 col-md-8 col-xl-10 z-index-10 px-0">
                <div className="d-none d-lg-flex justify-content-end">
                  <InvoiceDetails
                    invoice={invoice}
                    isSuperMiddleman={isSuperMiddleman}
                  />
                </div>
              </div>

              <div className="col-5 col-md-2 col-xl-1 px-0 color-white d-flex justify-content-center align-items-center
                text-center minH-40px-imp z-index-10 text-truncate
                br-top-right-8px br-bottom-left-8px br-bottom-right-0px br-bottom-left-md-0px br-bottom-right-md-8px"
                   style={{backgroundColor: invoiceColorState(invoice.state)}}>
                <div className="my-0 py-0">
                  <b className="color-white text-truncate">
                    {I18n.t(`js.indexInvoices.states.${invoice.state}`)}
                  </b>
                </div>
              </div>

              <div className="col-12 d-lg-none py-2 pr-1">
                <InvoiceDetails
                  invoice={invoice}
                />
              </div>
            </div>

            {
              invoiceRowsPresent(invoice) &&
              <div
                className={`row slide-animation-container slide-${invoice.display_content ? 'down' : 'up'} w-100 p-0 m-0 mt-minus-7px`}
                id={`invoice_${invoice.id}_content`}>
                <div className="col-md-2 col-xl-1 d-none d-lg-flex"></div>

                <div
                  className="col-12 col-xl-11 border-left-aiG-light-gray-imp border-right-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-radius-8px px-0 pt-1">
                  <div className="row w-100pb-1 px-0 m-0">
                    {
                      invoice.invoice_rows.map((invoice_row, i) => {
                        return <React.Fragment key={`row_${invoice_row.id}`}>
                          <div
                            className={`col-8 col-sm-10 col-lg-10 col-xl-11 d-flex justify-content-start align-items-center
                            py-2
                            ${invoice.invoice_rows.length % 2 === i % 2 ? 'bg-aiG-gray3-imp' : ''}`}>
                            {invoice_row.description}
                          </div>
                          <div
                            className={`col-4 col-sm-2 col-lg-2 col-xl-1 d-flex justify-content-end align-items-center
                            py-2
                            ${invoice.invoice_rows.length % 2 === i % 2 ? 'bg-aiG-gray3-imp' : ''}`}>
                            <b>{parseAmount(invoice_row.amount, 2, true)}{CURRENCY_EURO}</b>
                          </div>
                        </React.Fragment>
                      })
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceList;